import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useExecuteImportJob(shop: ShopDto) {
	const invalidateShop = useInvalidateShop(shop.id);

	return useApiMutation(
		"post",
		"/shops/{shopId}/imports/{importId}",
		{
			invalidate: invalidateShop,
			mapVariables: (importId: string) => ({
				params: { path: { shopId: shop.id, importId } },
			}),
		},
	);
}
